import { makeStyles } from '@material-ui/core/styles';

import { neutral } from 'shared/styles/colors';

export default makeStyles({
  headerDialogTitle: {
    fontWeight: 600,
    fontSize: '1.5rem',
    lineHeight: '2rem',
  },

  legend: {
    paddingBlock: '0.5rem',
    fontWeight: 400,
    lineHeight: '1.5rem',
    fontSize: '0.875rem',
    color: neutral['100'],
    '&.Mui-focused': {
      color: neutral['100'],
    },
  },
  radioGroup: {
    gap: '0.5rem',
  },
  radioOptionLabelTitle: {
    fontWeight: 400,
    lineHeight: '1.5rem',
  },

  textAreaContainer: {
    marginTop: '1rem',
  },
  textArea: {
    width: '100%',
    minHeight: '6rem',
    padding: '0.75rem',
    fontSize: '0.875rem',
    lineHeight: '1.5rem',
    resize: 'vertical',
    color: neutral[90],
    borderRadius: '0.5rem',
    backgroundColor: neutral[10],
    border: `1px solid ${neutral[30]}`,
    '&::placeholder': {
      color: neutral[60],
    },
    '&:focus': {
      borderColor: neutral[40],
      outline: 'none',
    },
  },
  characterCount: {
    marginTop: '0.5rem',
    fontSize: '0.75rem',
    lineHeight: '1.25rem',
    textAlign: 'right',
    color: neutral[60],
  },
});
